export type SearchQuery = {
  query?: string;
  country?: string[];
  industry?: string[];
  ratingType?: string;
};

export enum ItemType {
  UNKNOWN = 'UNKNOWN',
  ISIN = 'ISIN',
  LEI = 'LEI',
  SCOPEONEID = 'SCOPEONEID',
  EASYNUMBER = 'EASYNUMBER',
}

export type ArtifactId = {
  value: string;
  type: ItemType;
};

export type SelectedEntities = {
  count: number;
  itemIds: Record<string, string>;
  items: Record<string, string[][]>;
  type: ItemType | null;
};

export type PortfolioItem =
  | 'ENTITY'
  | 'ISSUER'
  | 'INSTRUMENT'
  | 'FUND'
  | 'ISSUE'
  | 'RATING_NEWS'
  | 'COMPANY_NEWS'
  | 'RESEARCH'
  | 'COMMENTARY'
  | 'MONITORING_NOTES'
  | 'EVENT';
